import { UAParser } from 'ua-parser-js';

// Create a parser instance and fetch results
const parser = new UAParser();
const result = parser.getResult();

export function getBrowser(): UAParser.IBrowser {
  return result.browser;
}

export function getCpu(): UAParser.ICPU {
  return result.cpu;
}

export function getDevice(): UAParser.IDevice {
  return result.device;
}

export function getEngine(): UAParser.IEngine {
  return result.engine;
}

export function getOS(): UAParser.IOS {
  return result.os;
}

export function getUA(): string | undefined {
  return result.ua;
}
